$(window).scroll(function() {
    if ($(document).scrollTop() > 150) {
        $('.site-header').addClass('stuck');
    } else {
        $('.site-header').removeClass('stuck');
    }
});
